import Toggle from '../../Common/Toggle';
import styles from './billPayMultiCard.scss';
import CustomAnchorTag from '../../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import IneligiblePopup from "../../Common/ineligiblePopup";
import ReactHtmlParser from 'react-html-parser';

export default class TableMultiRowContent extends React.Component {

    constructor(props) {
        super(props);
        this.eligibilityParams = {};
        this.onColor = true;
        this.toggleOn = true;
    }
    storeCustomerAccountData = () => {
        let customerAccountData = app.settingsService.getFormattedAccountDetails(this.props.settingsTableData);
        app.appService.setSessionstorage(app.appUtil.getAppConstants().CustomerAccountData, customerAccountData);
    }
    onDpToggle = (checked, billingFlag) => { app.appService.setSessionstorage('totalServiceCount', this.props.settingsTableData.serviceAccountCount); 
        let isManage = this.props.autoPay.isDpEnrolled;
        app.appService.setSessionstorage('billPayIdentifier',{'pageReload':false,'currentPage':this.props.currentPage});
        this.storeCustomerAccountData();
        this.props.onDpToggle(checked, isManage, billingFlag,'isMulti');
    }
    manageLink = () => { app.appService.setSessionstorage('totalServiceCount', this.props.settingsTableData.serviceAccountCount); 
        this.storeCustomerAccountData();
        app.appService.setSessionstorage('billPayIdentifier',{'pageReload':true,'currentPage':this.props.currentPage});
        let events = {
            alertDismissed: false, alertInteracted: false, manageAccount: true, makePayment: false, autoPayEnroll: false, paperlessEnroll: false, viewBill: false, viewUsage: false, custom: false, autopayCancel: false, paperlessCancel: false, sdpEnroll: false, sepEnroll: false, savingsPlan: false, paymentArrangement: false, componentClick: true, componentName: 'Auto Pay'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|billing_payment|none|auto_pay|page|manage`) : null;
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().BILLING.DP_MANAGE_LINK);
    };

    onPbToggle = (settingsTableDataSelected, isEnrolled) => {app.appService.setSessionstorage('totalServiceCount', settingsTableDataSelected.serviceAccountCount); 
    if(isEnrolled){
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:true, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Paperless Billing'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils.sendAAEvent("Toggle", `settings|billing_payment|none|paperless_billing|page|paperless_billing_toggle_off`);  
        this.props.openPbDeEnroll((settingsTableDataSelected));
    }else{
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:true, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Paperless Billing'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils.sendAAEvent("Toggle", `settings|billing_payment|none|paperless_billing|page|paperless_billing_toggle_on`);
        this.props.openPbEnroll(settingsTableDataSelected);}
    }
    openViewEdit = (settingsTableDataSelected) => { app.appService.setSessionstorage('totalServiceCount', settingsTableDataSelected.serviceAccountCount); 
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:true, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Paperless Billing'
        };
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|billing_payment|paperless_billing|none|none|page|manage`) : null;
        app.analyticsService.addPageLevelData('eventCapturing', events);
        this.props.openViewEdit(settingsTableDataSelected);
    }
    formatMailingAddress(mailingAddr) {
        let { careOfName, houseNumber, street, supplement, city, region, postalCode, poBox, poPostalCode } = mailingAddr,parts = [];
        return this.getCommaSeparatedAddr([[careOfName?`${this.capitaliser(careOfName)}`:null],[poBox?`PO box ${poBox}`:null],[houseNumber, this.capitaliser(street)],[supplement],[this.capitaliser(city)],[region, poPostalCode? this.capitaliser(poPostalCode.split('-')[0]):postalCode.split('-')[0]]]);
    }
    
    getCommaSeparatedAddr(fields) {
        let strs = [];
        for (let i=0; i<fields.length; i++) {
            let parts = [];
            for (let j=0; j<fields[i].length; j++)
                if (fields[i][j])
                    parts.push(fields[i][j]);
            if (parts.length){
                strs.push(parts.join(" "));
            }                
        }
        return strs.join(", ");
    }
    capitaliser (mySentence) {
      let words = mySentence?mySentence.trim().split(" "):[];
      mySentence?words.length <1 ? words.push(mySentence) : null:null;
      let reframedSentence = words.map((word) => {
          let reframed = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          return reframed;}).join(" ");
      return reframedSentence; }
    formatedMailingAddress(address, value) {
        switch (value) {
            case "mailingAddress": {
                let mailingAddrDetails=this.formatMailingAddress(address);
               return mailingAddrDetails;
            }

            case "custName": {
                let custName = address,
                    custNameHasComma = custName.includes(','),
                    nameSplit = custNameHasComma ? custName.split(',').map(part => part.trim()) : custName,
                    firstName = custNameHasComma ? nameSplit[1].charAt(0).toUpperCase() + nameSplit[1].slice(1).toLowerCase() : nameSplit,
                    lastName = custNameHasComma ? nameSplit[0].charAt(0).toUpperCase() + nameSplit[0].slice(1).toLowerCase() : '',
                    fullName = firstName + ' ' + lastName;
                return fullName;
            }
        }
    }
    fetchAccountData = (contractAccountNumber) => {
        let reqParams = {};
        reqParams['contractAccountNumber'] = contractAccountNumber;
        reqParams.sortDirection = this.props.sortDirection;
        let requestObj = reqParams;
        this.props.fetchData(requestObj, 'refresh');
    }
    getErrorMsgRgx = (error) => {
        let errorMsgRgx = new RegExp(`<p id="${error}">(.*?)</p>`, 'g');
        let defaulterrorMsgRgx = new RegExp(`<p id="comm-err">(.*?)</p>`, 'g');
        let errorMsgContent ="";
        let defaulterrorMsgContent ="";
        errorMsgContent = !_.isEmpty(this.props.ineligibleMessage) ? this.props.ineligibleMessage.body.match(errorMsgRgx) : "";
        defaulterrorMsgContent = !_.isEmpty(this.props.ineligibleMessage) ? this.props.ineligibleMessage.body.match(defaulterrorMsgRgx) : "";
        return errorMsgContent ? ReactHtmlParser(errorMsgContent) : ReactHtmlParser(defaulterrorMsgContent);

    }
     getEligibilityData = (eligibilityData, productCode) => {
        return _.filter(eligibilityData, function (item) {
          return item.programDescription === productCode;
        })[0];}

     getIneligibiltyReason = (program) =>{
       let autoPayData = this.getEligibilityData(this.props.settingsTableData.eligibilityData, program === 'autoPay'? app.appUtil.getAppConstants().AUTOPAY_CODE : app.appUtil.getAppConstants().PAPERLESS_CODE);
       let errorCode = program === 'autoPay'? '_DP' : '_OB';
       let errorMsgContent = this.getErrorMsgRgx(autoPayData.ineligibilityReason + errorCode);
       return errorMsgContent ;
    }
    showToggleOrNot = (toggleType) => {
        let maskedEmail = !_.isEmpty(this.props.pBilling.email) ? this.props.pBilling.email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c) : null;
        let content = this.getIneligibiltyReason(toggleType);
        let contentHeading = toggleType=== 'autoPay'? "Account Ineligible for Autopay" : "Account Ineligible for Paperless billing";
    
        switch (toggleType) {
            case "paperlessBilling": {
                let toggleDiv, contentDiv = null;
                if (this.props.pBilling === 'NoData') {
                    toggleDiv = <div className={styles.dataRowValueDown}>
                        <div>No Data Available</div>
                    </div>;
                } else {
                    toggleDiv = <div>
                        {this.props.settingsTableData.customerAccountActiveStatus !== "A" || this.props.pBilling.isObIneligible ? <IneligiblePopup isUnderline heading={contentHeading} content={content} linkName={"Ineligible"} /> : <Toggle
                            onColor={"#00664F"}
                            isToggleOn={this.props.pBilling.isObEnrolled}
                            isToggleOnGreen={this.onColor} handleChange={() => this.onPbToggle(this.props.settingsTableData, this.props.pBilling.isObEnrolled)}
                        />}</div>;
                    contentDiv = <div>
                        {this.props.settingsTableData.customerAccountActiveStatus === "A" && this.props.pBilling.isObEnrolled ? <div>
                            <div className={styles.sceFieldValue}>{maskedEmail}</div>
                            <CustomAnchorTag linkName={'Manage'} isBold onClick={() => this.openViewEdit(this.props.settingsTableData)} />
                        </div> : null}
                    </div>;
                }
                return { contentDiv, toggleDiv };
            }
            case "autoPay": {
                let toggleDiv, contentDiv = null;
                if (this.props.autoPay === 'NoData') {
                    toggleDiv = <div className={styles.dataRowValueDown}>
                        <div>No Data Available</div>
                    </div>;
                } else {
                    toggleDiv = <div className={styles.dataRowValueDown}>
                        {this.props.autoPay.isDpIneligible ? <IneligiblePopup isUnderline heading={contentHeading} content={content} linkName={"Ineligible"} /> : <Toggle
                            onColor={"#00664F"}
                            isToggleOn={this.props.autoPay.isDpEnrolled}
                            isToggleOnGreen={this.onColor}
                            handleChange={() => this.onDpToggle(!this.props.autoPay.isDpEnrolled, true)} />}</div>;
                    contentDiv = <div>
                        <div className={styles.sceFieldValue}>{this.props.autoPay.associatedDpBank}</div>
                        {this.props.autoPay.isDpEnrolled ? <CustomAnchorTag linkName={'Manage'} onClick={this.manageLink} isBold /> : null}
                    </div>;
                }
                return { contentDiv, toggleDiv };
            }
        }
    }
displayEdit=(contractAccountNumber)=>{
        app.appService.setSessionstorage('displayAddress', true);
        app.appService.setSessionstorage('canumber', contractAccountNumber);
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().PROFILE_SETTINGS.UPDATE_MAILING_ADDRESS);}
    render() {
        return <div className={styles.sceCardDiv + "container"}>
            <div className={styles.sceMainCardDiv}>
                <div className={styles.sceAccountDetails}>Account:&nbsp;<span data-pii-encrypt>{this.props.settingsTableData.contractAccountNumber}</span>
                </div>
                <div className={styles.sceAccDetailsAlt}>
                    <div className={styles.sceAccDetailsField}>
                        <span className={styles.sceFieldName}>Customer Name: </span><span data-pii-encrypt  className={styles.sceFieldVal}>{this.formatedMailingAddress(this.props.settingsTableData.customerAccountName, "custName")}</span>
                    </div>
                    <div className={styles.sceAccDetailsMailingAddr} >
                        <span className={styles.sceFieldName}>Mailing Address: </span><span data-pii-encrypt className={styles.sceFieldVal}>{this.formatedMailingAddress(this.props.settingsTableData.mailingAddress, "mailingAddress")}<a href="javascript:"  onClick={()=>this.displayEdit(this.props.settingsTableData.contractAccountNumber)}className={styles.anchorTag}>Edit <i aria-hidden className='fas fa-pencil-alt' /></a></span>
                    </div>
                </div>
            </div>
            <div className={styles.sceToggleContainer}>
                <div className={styles.sceCardContainer + " col-xs-12 col-sm-6"}>
                    <div>
                        <div className={styles.sceFieldTitle}>Paperless Billing</div>
                        {this.showToggleOrNot("paperlessBilling").contentDiv}
                    </div>
                    {this.showToggleOrNot("paperlessBilling").toggleDiv}
                </div>
                <div className={styles.sceCardContainer + " col-xs-12 col-sm-6"}>
                    <div>
                        <div className={styles.sceFieldTitle}>Auto Pay</div>
                        {this.showToggleOrNot("autoPay").contentDiv}
                    </div>
                    {this.showToggleOrNot("autoPay").toggleDiv}
                </div>
            </div>
        </div>;
    }
}
